import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import Information from "./Information";
import Progress from "./slices/Progress";
import ErrorHandler from "./slices/ErrorHandler";
import AppDrawer from "./slices/AppDrawer";
import Menu from "./slices/Menu";
import Party from "./slices/Party";
import Drink from "./slices/Drink";
import Order from "./slices/Order";
import Organizer from "./slices/Organizer";
import Admin from "./slices/Admin";
import MemberForm from "./slices/MemberForm";
import EntranceUser from "./slices/EntranceUser";
import CreateUser from "./slices/CreateUser";
import Login from "./slices/Login";
import PasswordSetting from "./slices/PasswordSetting";
import PasswordSettingEdit from "./slices/PasswordSettingEdit";
import UserInfo from "./slices/UserInfo";
import ApplicationForm from "./slices/ApplicationForm";
import PartyDetail from "./slices/PartyDetail";

const reducer = combineReducers({
    Information: Information,
    Progress: Progress,
    ErrorHandler: ErrorHandler,
    Menu: Menu,
    Party: Party,
    Drink: Drink,
    AppDrawer: AppDrawer,
    Order: Order,
    Organizer: Organizer,
    Admin: Admin,
    MemberForm: MemberForm,
    EntranceUser: EntranceUser,
    CreateUser: CreateUser,
    Login: Login,
    PasswordSetting: PasswordSetting,
    PasswordSettingEdit: PasswordSettingEdit,
    UserInfo: UserInfo,
    ApplicationForm: ApplicationForm,
    PartyDetail: PartyDetail,
});

const store = configureStore({ reducer });

export default store;
